import React, { useState, useEffect } from "react";
import { Box, Flex, Center, Spinner, SimpleGrid, useColorModeValue } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import CardsTable from "views/admin/dataTables/components/CardsTable";
import useEndpoints from "providers/Endpoints";
import constants from "providers/Constants";
import { useSearch } from "contexts/SearchContext";

export default function Cards() {
  const { t } = useTranslation();
  const { searchQuery } = useSearch();
  const [cards, setCards] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [wallets, setWallets] = useState([]);
  const [loading, setLoading] = useState(true);

  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const textColorBrand = useColorModeValue("brand.500", "white");

  const endpoints = useEndpoints();

  useEffect(() => {
    getCardCurrencies();
  }, []);

  if (loading) {
    return (
      <Center height="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }} pb="40px">
      <SimpleGrid
        mb='20px'
        columns={{ sm: 1, md: 1 }}
        spacing={{ base: "20px", xl: "20px" }}>
        <CardsTable
          sortArray={[1, 5, 10, 50]}
          index={(value) => { }}
          tableData={cards}
          currenciesData={currencies}
          walletsData={wallets}
          searchQuery={searchQuery}
        />
      </SimpleGrid>
    </Box>
  );

  // Get card currencies
  async function getCardCurrencies() {
    setLoading(true);
    endpoints.getCardCurrencies((error, data) => {
      setLoading(false);
      if (error) {
        constants.showToast(
          "error",
          t("FAILED"),
          error?.message || t("Snap! Something went wrong, Try again")
        );
      } else {
        setCurrencies(data);
      }
      getFiatWallets();
    });
  }

  // Get fiat wallets
  async function getFiatWallets() {
    setLoading(true);
    endpoints.getFiatWallets((error, data) => {
      setLoading(false);
      if (error) {
        constants.showToast(
          "error",
          t("FAILED"),
          error?.message || t("Snap! Something went wrong, Try again")
        );
      } else {
        setWallets(data || []);
      }
      getPaymentCards();
    });
  }

  // Get payment cards
  async function getPaymentCards(start_item = 0, end_item = 50, page = 1) {
    setLoading(true);
    endpoints.getPaymentCards(start_item, end_item, page, (error, data) => {
      setLoading(false);
      if (error) {
        constants.showToast(
          "error",
          t("FAILED"),
          error?.message || t("Snap! Something went wrong, Try again")
        );
      } else {
        setCards(data || []);
      }
    });
  }
}
